import { useContext, useEffect, useState } from "react"

import { useLocalSearchParams } from "expo-router"
import _ from "lodash"

import { Client, ClientCollection, User } from "wealthmode-frontend/backend"
import { Text } from "wealthmode-frontend/gluestack/ui"

import { DetailField, DetailLink, ResourceDetail } from "@/components"
import { BackendContext } from "@/context"
import { CLIENT_STATE_COLORS, CLIENT_STATE_LABELS } from "@/lib/labels"

export default function ClientDetail() {
  const { client_id } = useLocalSearchParams<{ client_id: string }>()
  const backend = useContext(BackendContext)

  const [client, setClient] = useState<Client>()

  useEffect(() => {
    ;(async () => {
      const clients = backend.collection("clients") as ClientCollection
      const model = clients.model(client_id)
      await model.fetch({ reload: true })

      setClient(model)
    })().catch((err) => {
      console.error("Error: " + err)
      throw err
    })
  }, [backend, client_id])

  const fields: DetailField[] = []
  const links: DetailLink[] = [
    { href: `/clients/${client_id}/accounts`, label: "Accounts" },
    { href: `/clients/${client_id}/contributions`, label: "Contributions" },
    { href: `/clients/${client_id}/users`, label: "Users" },
  ]

  let name: string | null | undefined

  if (client) {
    const state = client.attributes.state
    const users = (client.embed("users") as User[]) ?? []
    name = _.find(users, (user) => user.hasName())?.attributes.name

    fields.push(
      { label: "Created", value: new Date(client.attributes.created * 1000).toLocaleString() },
      {
        label: "Status",
        value: (
          <Text className={CLIENT_STATE_COLORS[state] ?? "text-foreground-secondary"}>
            {CLIENT_STATE_LABELS[state] ?? state}
          </Text>
        ),
      },
      { label: "Referral Code", value: client.attributes.referral_code ?? "--" },
    )
  }

  return (
    <ResourceDetail
      title={name || "Client"}
      subtitle={client_id}
      loading={!client}
      fields={fields}
      links={links}
    />
  )
}
